import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface SavedMessageState {
  savedMessage?: string;
}

// Zamjena za zeleni toast kod kreiranja/uređivanja entiteta — traje predugo
// da bi ga korisnik uočio. Poruka se prenosi kroz navigate(path, { state })
// na odredišnu (detail) stranicu, prikaže kao StatusBanner, a odmah se
// briše iz history state-a (replace) da se ne pojavi opet ako korisnik
// osvježi stranicu ili joj se izravno vrati.
export const useSavedMessage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialMessage = (location.state as SavedMessageState | null)?.savedMessage ?? null;
  const [message, setMessage] = useState<string | null>(initialMessage);

  useEffect(() => {
    if (initialMessage) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [initialMessage, location.pathname, navigate]);

  return [message, setMessage] as const;
};
